import { Injectable, inject } from '@angular/core';
import {
  Analytics,
  setAnalyticsCollectionEnabled,
  setUserId,
  setUserProperties,
  logEvent
} from '@angular/fire/analytics';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  public angularFireAnalytics: Analytics = inject(Analytics);
  constructor() { }

  gaEnableAnalytics(flag: boolean) {
    setAnalyticsCollectionEnabled(this.angularFireAnalytics, flag);
  }

  gaSetUserId(id: string) {
    try {
      setUserId(this.angularFireAnalytics, id);
    } catch (e) {
      console.log('gaSetUserId err: ', e);
    }
  }

  gaSetUserProperties(properties: Record<string, any>) {
    try {
      setUserProperties(this.angularFireAnalytics, properties);
    } catch (e) {
      console.log('gaSetUserProperties err: ', e);
    }
  }

  gaLogEvent(eventName: string, eventParams?: any) {
    try {
      logEvent(this.angularFireAnalytics, eventName, eventParams);
    } catch (e) {
      console.log('gaLogEvent err: ', e);
    }
  }

  gaLogLoginEvent(profileObject: any, logOTPSucess?: boolean) {
    try {
      if (profileObject) {
        const userProp = {
          userName: profileObject.USER_NAME || '',
          userEmail: profileObject.EMAIL || '',
          userRole: profileObject.USER_ROLE || ''
        };
        const userID = profileObject.EMAIL || '';
        this.gaSetUserId(userID);
        this.gaSetUserProperties(userProp);
        if (logOTPSucess) {
          this.gaLogEvent('otp_login_success', userProp);
        }
      }
    } catch (e) {
      console.log('Analytics log error: ', e);
    }
  }

  gaSetUserOnReload(userID: string) {
    this.gaSetUserId(userID);
  }
}
